import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toggle-view',
  templateUrl: './toggle-view.component.html',
  styleUrls: ['./toggle-view.component.css']
})
export class ToggleViewComponent {

  @Output() changeView= new EventEmitter<any>();
  toggle: boolean =true;

  constructor() { }

  /**
   * Determines whether click on
   */
  onClick(){
    this.toggle = !this.toggle;
    this.changeView.emit(this.toggle);
  }
}
